import newsService from "@/services/news";
export default {
  state: {
    newsDefault: {
      date: Date.now(),
      title: "",
      degreeType: null,
      topics: [],
      author: "",
      content: "",
      image: ""
    },
    news: {}
  },
  mutations: {
    setNews(state, payload) {
      state.news = { ...state.newsDefault, ...payload };
    }
  },
  actions: {
    async setNews({ commit }, payload) {
      payload.degreeType =
        (payload.degreeType && payload.degreeType.id) ||
        payload.degreeType ||
        null;

      let topics = [];
      (payload.topics || []).forEach(topic => {
        topics.push(topic.id || topic);
      });

      payload.topics = topics;
      commit("setNews", payload);
    },
    resetNews({ commit }) {
      commit("setNews", {});
    },
    async removeNews(context, payload) {
      const { id } = payload;
      await newsService.remove(id);
    }
  }
};
